import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import axios from "axios";
import { Constant, imageDomain } from "../../../helper/Constants.js";

class ExamItemGrid extends Component {
  state = {
    exams: [],
    page: 1,
    limit: 8,
    totalPages: 1,
    loading: false,
  };

  componentDidMount() {
    this.fetchExams(1);
  }

  // Remove HTML & shorten text
  cleanText = (html = "") => {
    if (!html) return "";
    const text = html.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
    return text.length > 120 ? text.substring(0, 120) + "..." : text;
  };

  // Build correct image URL for exam_poster
  buildImageUrl = (img) => {
    if (!img) return process.env.PUBLIC_URL + "/assets/images/default-course.jpg";
    if (/^https?:\/\//i.test(img)) return img;
    if (imageDomain)
      return imageDomain.replace(/\/$/, "") + (img.startsWith("/") ? "" : "/") + img;

    return process.env.PUBLIC_URL + "/" + img;
  };

  // Format date nicely
  formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return "N/A";
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  fetchExams = async (page = 1) => {
    this.setState({ loading: true });

    try {
      const { limit } = this.state;
      const { upcoming } = this.props; // optional prop to filter upcoming exams

      // Website/App URL for public list (paginated)
      // Map this in your Constants to: GET /competitive-exams
      const baseUrl =
        (Constant.getUrls.getAllExams)

      const params = new URLSearchParams();
      params.append("page", page);
      params.append("limit", limit);
      if (upcoming) params.append("upcoming", "true");

      const resp = await axios.get(`${baseUrl}?${params.toString()}`);

      // Backend response shape:
      // {
      //   status,
      //   message,
      //   data: result.docs,
      //   pagination: { totalDocs, totalPages, page, limit, ... }
      // }
      const payload = resp?.data || {};
      const docs = Array.isArray(payload.data) ? payload.data : [];
      const pagination = payload.pagination || {};

      const totalPages = pagination.totalPages || 1;

      this.setState({
        exams: docs,
        page: pagination.page || page,
        totalPages: totalPages,
        loading: false,
      });
    } catch (error) {
      console.error("Failed to fetch exams", error);
      this.setState({ exams: [], loading: false });
    }
  };

  handlePageChange = (newPage) => {
    const { totalPages } = this.state;
    if (newPage < 1 || newPage > totalPages) return;
    this.fetchExams(newPage);
  };

  render() {
    const { exams, page, totalPages, loading } = this.state;

    return (
      <Fragment>
        {/* Exam Items */}
        {loading ? (
          <Col md="12">
            <p>Loading exams...</p>
          </Col>
        ) : exams.length > 0 ? (
          exams.map((exam, i) => {
            const link = `/exam-details/${exam._id}`;
            const title = exam.exam_name || "Untitled Exam";
            const desc = this.cleanText(exam.description || "");
            const image = this.buildImageUrl(exam.exam_poster);
            const examDate = this.formatDate(exam.exam_date);
            const examType = exam.exam_type || "N/A";
            const venue = exam.exam_venue || "N/A";

            return (
              <Col lg="6" md="12" key={exam._id || i}>
                  <Link to={process.env.PUBLIC_URL + link}>
                <div className="course-item">
                  {/* Poster + basic overlay */}
                    <div
                      className="course-image"
                      style={{
                        backgroundImage: `url(${image})`,
                      }}
                    >
                      <div className="author-img d-flex">
                        <div className="img">
                          <img
                            src={process.env.PUBLIC_URL + `/assets/images/author.jpg`}
                            alt="Admin"
                          />
                        </div>
                        <div className="title">
                          <p>Admin</p>
                          <span>Competitive Exam</span>
                        </div>
                      </div>

                      {/* You can repurpose this "price" badge */}
                      <div className="course-price">
                        <p>{examType.toUpperCase()}</p>
                      </div>
                    </div>
                  {/* </Link> */}

                  {/* Content */}
                  <div className="course-content">
                    <h6 className="heading">
                      <Link to={process.env.PUBLIC_URL + link}>{title}</Link>
                    </h6>

                    <p className="desc">{desc}</p>

                    <div className="course-face d-flex justify-content-between">
                      {/* Exam Date */}
                      <div className="duration">
                        <p>
                          <i className="las la-calendar" /> {examDate}
                        </p>
                      </div>

                      {/* Venue */}
                      <div className="rating text-black">
                        <p>
                          <i className="las la-map-marker-alt" /> {venue}
                        </p>
                      </div>

                      {/* Type */}
                      <div className="student">
                        <p>
                          <i className="las la-laptop-code"></i> {examType}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                  </Link>

              </Col>
            );
          })
        ) : (
          <Col md="12">
            <p>No exams found!</p>
          </Col>
        )}

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <Col md="12" className="text-center mt-4">
            <div className="course-pagination">
              <button
                className="btn btn-sm btn-outline-primary mr-2"
                disabled={page === 1}
                onClick={() => this.handlePageChange(page - 1)}
              >
                Prev
              </button>

              <span className="mx-2">
                Page {page} of {totalPages}
              </span>

              <button
                className="btn btn-sm btn-outline-primary ml-2"
                disabled={page === totalPages}
                onClick={() => this.handlePageChange(page + 1)}
              >
                Next
              </button>
            </div>
          </Col>
        )}
      </Fragment>
    );
  }
}

export default ExamItemGrid;
